/* Rosterpress team bundle: pure pricing + cart payload. Shared by the page (window.RPBundleCore) and node tests. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api; else root.RPBundleCore = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  /* Team name: no practical cap since 30/09 (a buyer needed more room); 100 only guards abuse. Names over 6 words print on 2 lines,
     or the shopper splits it with a comma (08/10, long team names). */
  var TEAM_MAX = 100, TEAM_WRAP_WORDS = 6, NAME_MAX = 20;   // owner 22/10: player names up to 20 characters everywhere

  function sanitize(text, max) {
    return String(text == null ? '' : text).toUpperCase().replace(/[^A-Z0-9 .,'&-]/g, '').slice(0, max);
  }

  function personalized(s) {
    return !!s.pers && !!(sanitize(s.name, NAME_MAX).trim() || sanitize(s.team, TEAM_MAX).trim());
  }

  /* Text drawn on the mockup (display only - the cart uses personalized/buildItems): personalization off -> none;
     on with nothing typed -> sample YOUR NAME / TEAM NAME where they go; anything typed -> exactly what will print. */
  function previewText(s) {
    if (!s.pers) return null;
    var nm = sanitize(s.name, NAME_MAX).trim(), tm = sanitize(s.team, TEAM_MAX).trim();
    if (!nm && !tm) return { name: 'YOUR NAME', team: 'TEAM NAME', sample: true };
    return { name: nm, team: tm, sample: false };
  }

  /* $X off every shirt (rules.off_each; $10 since 28/09), or Buy 1 Get 1 on the cheapest shirts — never both, the bigger discount wins (mirrors the two non-combinable automatic discounts). */
  function priceFor(prices, rules) {
    var n = prices.length;
    var base = prices.reduce(function (t, p) { return t + p; }, 0);
    var order = prices.map(function (p, i) { return { i: i, p: p }; })
      .sort(function (a, b) { return a.p - b.p || b.i - a.i; });
    var freeN = rules.bogo ? Math.floor(n / 2) : 0;
    var free = new Set(order.slice(0, freeN).map(function (o) { return o.i; }));
    var discFree = 0; free.forEach(function (i) { discFree += prices[i]; });
    var discOff = n * rules.off_each;
    if (discFree > discOff) return { n: n, base: base, free: free, freeN: freeN, mode: 'free', disc: discFree };
    return { n: n, base: base, free: new Set(), freeN: 0, mode: 'off', disc: discOff };
  }

  /* Price hint under the add-to-cart button: what 1 shirt and 2 shirts cost at the product's cheapest variant price
     (same maths as priceFor). twoFree = the 2-shirt price comes from Buy 1 Get 1. null when there are no prices. */
  function hintPrices(prices, rules) {
    if (!prices || !prices.length) return null;
    var min = Math.min.apply(null, prices);
    var one = priceFor([min], rules), two = priceFor([min, min], rules);
    return { one: one.base - one.disc, two: two.base - two.disc, twoFree: two.mode === 'free' };
  }

  function calc(items, rules, protect) {
    var r = priceFor(items.map(function (s) { return s.price; }), rules);
    var persN = items.filter(function (s) { return s.pers; }).length;
    var persFee = persN * rules.pers_price;
    var ship = r.n >= rules.free_ship_at ? 0 : rules.ship_estimate;
    var prot = protect ? rules.protection_price : 0;
    var total = r.base - r.disc + persFee + ship + prot;
    var full = r.base + persFee + rules.ship_estimate + prot;
    r.persN = persN; r.persFee = persFee; r.ship = ship; r.prot = prot;
    r.total = total; r.full = full; r.saved = full - total;
    return r;
  }

  function shirtPrice(i, r, price, rules) {
    if (r.free.has(i)) return 0;
    return r.mode === 'off' ? price - rules.off_each : price;
  }

  function nextFree(n, rules) {
    if (!rules.bogo) return null;
    for (var k = 1; k <= 2 && n + k <= rules.max; k++) {
      var more = Math.floor((n + k) / 2) - Math.floor(n / 2);
      if (more > 0) return { k: k, more: more };
    }
    return null;
  }

  function bundleId(nowMs) {
    return 'B' + Number(nowMs).toString(36).toUpperCase();
  }

  /* Shopper free text for an order note: one line, no markup characters, capped. */
  function cleanNote(text, max) {
    return String(text == null ? '' : text).replace(/[<>]/g, '').replace(/[\u0000-\u001f\u007f]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, max);
  }

  /* Name / team text laid over a library design: centre of the box (x, y, w, h in % of the image) in a W × H viewBox,
     font size 90% of the box height, shrunk so the text (≈0.5em per letter) fits the box width. */
  /* Team name as printed lines. "A, B" = the shopper's own split (A line 1, B line 2; later commas dropped). Otherwise up to
     TEAM_WRAP_WORDS words on one line, longer names split into 2 lines of similar length. */
  function teamLines(text) {
    var parts = String(text == null ? '' : text).split(',').map(function (p) { return p.trim().split(/\s+/).join(' '); });
    if (parts.length > 1) {
      var l1 = parts[0], l2 = parts.slice(1).filter(Boolean).join(' ');
      if (l1 && l2) return [l1, l2];
      return [l1 || l2];
    }
    var w = parts[0].split(/\s+/);
    if (w.length <= TEAM_WRAP_WORDS) return [w.join(' ')];
    var best = 1, bestLen = Infinity;
    for (var i = 1; i < w.length; i++) {
      var l = Math.max(w.slice(0, i).join(' ').length, w.slice(i).join(' ').length);
      if (l < bestLen) { bestLen = l; best = i; }
    }
    return [w.slice(0, best).join(' '), w.slice(best).join(' ')];
  }

  /* text = one string or an array of lines; lines stack 1.05 font sizes apart around the box centre (y = centre of the block). */
  function overlayGeom(box, text, W, H, cw) {  // cw = glyph width / font size (0.5 condensed; wider faces pass their own)
    var lines = Array.isArray(text) ? text : [text];
    var bw = box.w / 100 * W, bh = box.h / 100 * H;
    var fs = 0.9 * bh / (1 + (lines.length - 1) * 1.05);
    var longest = lines.reduce(function (m, l) { return Math.max(m, l.length); }, 0);
    if (longest) fs = Math.min(fs, bw / (longest * (cw || 0.5)));
    return { x: (box.x + box.w / 2) / 100 * W, y: (box.y + box.h / 2) / 100 * H, fs: fs, lh: fs * 1.05, lines: lines };
  }

  /* Text colour as the print team should read it: "Auto" becomes the colour the preview actually showed
     (dark undefined = the studio never measured the print area). */
  function textColorLabel(col, dark) {
    if (col.id !== 'auto') return col.label;
    return col.label + (dark === undefined ? ' (our designers pick)' : ' (' + (dark ? 'black' : 'white') + ')');
  }

  /* Design studio -> bundle: apply only what the shopper changed in the studio (opened = shirt 1's name/team when the
     studio opened). A new name goes on shirt 1; a new team replaces the old team (or a blank one) on shirt 1 and on
     every personalized shirt. Other page edits and personalization switched off stay as they are. */
  function applyStudioText(shirts, opened, chosen) {
    if (chosen.name !== opened.name && shirts[0]) {
      shirts[0].name = chosen.name;
      if (chosen.name) shirts[0].pers = true;
    }
    if (chosen.team !== opened.team) {
      shirts.forEach(function (s, i) {
        if ((s.team === opened.team || !s.team) && (i === 0 || s.pers)) {
          s.team = chosen.team;
          if (i === 0 && chosen.team) s.pers = true;
        }
      });
    }
    return shirts;
  }

  /* Library products (custom.library metafield): name/team boxes of a shirt style, and which print areas are light. */
  function libraryBoxes(lib, style) {
    return (lib && lib.boxes && lib.boxes[style]) || null;
  }
  function libraryTone(lib, style, color) {
    return (lib && lib.tone && lib.tone[style + '|' + color]) || {};
  }

  /* Chest icon: the bestsellers print a small one-colour sport icon just above the player's name. Our own drawings in a
     100 × 100 box (bowling: drawn with 9Router, picked by the owner, vectorised); no colours inside, the page paints them
     in the name's colour. Holes are cut with fill-rule evenodd. */
  function ring(cx, cy, r) { return 'M' + (cx - r) + ' ' + cy + 'a' + r + ' ' + r + ' 0 1 0 ' + 2 * r + ' 0a' + r + ' ' + r + ' 0 1 0 ' + -2 * r + ' 0Z'; }
  function holes(d) { return '<path fill-rule="evenodd" d="' + d + '"/>'; }
  var SPORT_ICONS = {
    bowling: { label: 'Bowling', svg:
      holes('M24.9 73.0L24.6 72.1L24.1 71.6L22.6 71.3L3.1 73.0L2.4 73.1L2.4 73.3L10.0 74.1L23.7 74.8L24.6 74.2ZM24.8 66.1L24.4 65.3L23.6 64.9L21.8 64.9L2.2 66.6L0.0 67.0L0.0 67.2L9.3 67.8L23.3 68.4L24.5 67.7L24.8 67.1ZM26.5 59.5L25.7 58.5L25.3 58.3L24.2 58.3L5.8 60.6L5.7 60.9L25.1 61.8L25.7 61.6L26.5 60.6ZM84.4 55.6L83.8 55.5L75.9 58.0L72.1 60.3L67.2 65.4L63.8 70.4L63.2 71.4L63.2 72.3L64.8 74.8L66.8 76.7L67.5 77.0L68.4 77.0L74.8 74.3L77.8 72.5L81.1 70.1L83.6 67.4L88.0 60.4L88.0 60.0L87.2 58.6ZM87.2 53.0L85.9 54.0L85.9 54.3L87.9 56.2L89.1 57.9L89.3 58.4L89.7 58.6L90.9 57.8L91.1 57.3L90.4 56.0L89.2 54.5L87.6 53.1ZM41.7 51.5L38.9 52.1L35.4 53.5L32.7 55.4L30.4 57.7L29.0 59.7L27.4 63.6L26.8 66.3L26.8 69.8L27.4 72.5L28.6 75.5L30.3 78.1L32.3 80.1L34.8 81.8L38.2 83.3L41.0 83.8L43.9 83.8L46.8 83.3L50.7 81.6L52.8 80.1L55.1 77.8L57.1 74.8L58.5 71.2L59.0 68.7L59.0 65.5L58.3 62.4L57.1 59.5L55.7 57.3L53.6 55.1L51.3 53.5L48.4 52.2L45.2 51.5ZM46.3 62.6L47.0 62.7L47.7 63.0L48.2 63.6L48.6 64.2L48.5 65.8L47.6 66.7L46.8 67.1L46.0 67.1L45.2 66.7L44.5 66.1L44.2 65.4L44.2 64.3L44.4 63.8L45.3 62.9ZM50.7 58.6L51.4 58.8L52.1 59.1L52.6 59.6L53.0 60.3L53.0 61.5L52.7 62.0L52.2 62.7L51.3 63.1L50.2 63.1L49.6 62.8L48.9 62.1L48.6 61.4L48.6 60.5L48.9 59.7L49.7 59.0ZM43.9 55.9L44.5 55.8L45.2 55.9L45.8 56.2L46.7 57.3L46.8 58.4L46.5 59.2L46.0 59.8L45.1 60.3L44.1 60.3L43.3 60.0L42.7 59.3L42.3 58.5L42.3 57.7L42.7 56.9ZM97.9 46.6L96.7 46.2L94.9 46.2L93.2 46.8L90.9 48.8L88.8 51.3L88.8 51.6L89.4 52.0L91.6 54.3L92.8 56.3L93.1 56.3L97.5 54.2L99.3 52.4L99.9 51.2L100.0 49.5L99.2 47.7ZM69.9 41.9L63.9 46.2L61.5 48.6L60.2 50.5L59.3 53.6L57.9 57.2L58.8 58.5L60.0 61.4L60.5 63.5L60.8 66.5L61.5 66.7L62.4 66.6L66.6 62.8L71.2 57.8L73.3 54.0L74.1 51.4L75.3 45.2L72.4 43.0ZM72.2 38.6L71.3 40.3L73.7 41.5L75.2 42.5L76.1 43.4L76.4 43.4L77.2 42.3L77.5 41.8L76.5 40.8L74.6 39.5L73.1 38.7ZM24.8 40.8L25.5 42.9L26.0 46.5L26.8 49.5L28.3 52.5L30.3 54.9L30.6 54.9L33.5 52.6L36.7 51.0L39.4 50.1L43.1 49.7L43.0 48.9L41.7 46.4L40.0 44.1L38.2 42.2L30.4 37.2L29.3 37.5L27.8 38.4ZM27.9 33.8L27.5 33.8L25.4 34.9L23.4 36.3L22.4 37.3L22.4 37.5L23.5 38.9L23.9 38.9L25.1 37.9L26.9 36.5L28.9 35.6L28.8 35.1ZM49.8 32.8L45.5 41.4L44.9 44.4L45.0 49.7L47.6 50.0L50.9 51.1L53.4 52.5L56.3 55.3L56.7 55.3L58.1 51.5L59.2 46.7L59.2 43.4L58.5 40.3L56.2 33.3L52.8 32.7ZM79.5 29.3L78.4 29.4L77.4 29.9L75.6 31.4L74.3 33.7L73.3 36.4L73.3 36.8L74.3 37.1L76.6 38.4L78.7 40.3L78.9 40.3L82.4 36.9L83.0 36.0L83.7 34.2L83.7 32.8L82.9 31.1L81.7 30.0L80.7 29.5ZM50.0 28.7L50.0 30.7L53.0 30.6L56.3 31.2L56.6 29.8L56.5 29.0L53.5 28.4L51.2 28.4ZM20.4 24.7L19.6 24.8L18.1 25.5L16.8 26.6L16.2 27.8L16.0 29.5L16.3 30.9L17.5 32.8L20.8 35.8L21.1 35.8L23.4 33.8L24.7 32.9L26.7 32.1L26.8 31.7L25.5 28.4L24.5 26.8L23.1 25.5L21.9 24.9ZM52.5 16.4L51.6 16.8L50.5 17.8L49.6 19.7L49.3 20.6L49.3 23.2L49.9 26.5L53.6 26.4L57.1 27.0L58.3 23.4L58.6 21.8L58.6 20.2L58.2 18.7L57.8 17.9L56.8 17.0L56.0 16.5L54.9 16.2L53.4 16.2Z') },
    darts: { label: 'Darts', svg:
      holes(ring(44, 56, 38) + ring(44, 56, 31) + ring(44, 56, 22) + ring(44, 56, 15) + ring(44, 56, 6)) +
      '<path transform="translate(58.7 41.3) rotate(45)" d="M-3.5 -8h7v16l-3.5 10l-3.5 -10zM-1.6 -30h3.2v24h-3.2zM-1 -30L-10 -46L-7 -26zM1 -30L10 -46L7 -26z"/>' },
    billiards: { label: 'Billiards', svg:
      holes(ring(40, 60, 32) + ring(40, 52, 14) + ring(40, 45.5, 5) + ring(40, 45.5, 2.2) + ring(40, 57, 6) + ring(40, 57, 2.8)) +
      '<polygon points="84.5,96 91.5,96 80.3,8 77.7,8"/><polygon points="77.9,6 80.1,6 79.8,2 78.2,2"/>' },
    golf: { label: 'Golf', svg:
      '<rect x="16" y="8" width="3.5" height="84"/><polygon points="19.5,9 48,19 19.5,29"/><ellipse cx="18" cy="92" rx="14" ry="4"/>' +
      holes(ring(66, 50, 20) + ring(58, 43, 2.2) + ring(66, 39, 2.2) + ring(74, 43, 2.2) + ring(61, 52, 2.2) + ring(71, 52, 2.2) + ring(66, 60, 2.2)) +
      '<polygon points="54,70 78,70 70,76 68,94 66,97 64,94 62,76"/>' },
    cornhole: { label: 'Cornhole', svg:
      holes('M10 90L90 90L72 34L28 34Z' + ring(50, 50, 8)) +
      '<rect x="56" y="4" width="26" height="24" rx="5" transform="rotate(18 69 16)"/>' },
    disc_golf: { label: 'Disc Golf', svg:
      '<rect x="20" y="10" width="60" height="7" rx="2"/><rect x="47.5" y="10" width="5" height="82"/><rect x="34" y="89" width="32" height="6" rx="2"/>' +
      '<path d="M24 17L28 17L49 50L46 50ZM36 17L39.5 17L50 50L47.5 50ZM48.5 17L51.5 17L51.5 50L48.5 50ZM60.5 17L64 17L52.5 50L50 50ZM72 17L76 17L54 50L51 50Z"/>' +
      '<rect x="17" y="50" width="66" height="5" rx="2"/><polygon points="21,55 79,55 71,71 29,71"/>' },
    pickleball: { label: 'Pickleball', svg:
      '<g transform="translate(36 44) rotate(-28)"><rect x="-14" y="-40" width="28" height="40" rx="12"/><rect x="-4" y="-2" width="8" height="36" rx="2"/></g>' +
      '<g transform="translate(64 44) rotate(28)"><rect x="-14" y="-40" width="28" height="40" rx="12"/><rect x="-4" y="-2" width="8" height="36" rx="2"/></g>' +
      holes(ring(82, 84, 11) + ring(78, 80, 1.8) + ring(86, 80, 1.8) + ring(78, 88, 1.8) + ring(86, 88, 1.8)) },
    fishing: { label: 'Fishing', svg:
      holes('M4 30C14 16 36 14 52 30C36 46 14 44 4 30Z' + ring(14, 27, 2.6)) + '<path d="M50 30L64 20L61 30L64 40Z"/>' +
      '<path d="M76 16H82V72A16 16 0 0 1 50 72V60H56V72A10 10 0 0 0 76 72ZM50 60L53 51L56 60Z"/>' + holes(ring(79, 12, 4.5) + ring(79, 12, 2)) }
  };
  function sportOf(tags) {
    var t = (tags || []).filter(function (x) { return /^sport_/.test(x); })[0];
    var s = t ? t.slice(6) : 'bowling';
    return SPORT_ICONS[s] ? s : 'bowling';
  }
  /* Icon box in a W × H viewBox: centred over the name box, 2.4 name-heights tall, a small gap above the name. */
  function iconGeom(box, W, H) {
    var bh = box.h / 100 * H, size = 2.4 * bh;
    return { x: (box.x + box.w / 2) / 100 * W - size / 2, y: box.y / 100 * H - 0.1 * bh - size, size: size };
  }

  /* "linear-gradient(180deg,#FFF6C8 0%,#E8C45A 38%,…)" -> [{color, offset}] for an SVG <linearGradient> (metallic text). */
  function cssStops(css) {
    var out = [], re = /(#[0-9a-fA-F]{3,8})\s+(\d+(?:\.\d+)?)%/g, m;
    while ((m = re.exec(String(css == null ? '' : css)))) out.push({ color: m[1], offset: +m[2] });
    return out;
  }

  /* First per-shirt picker: "style" (merged products, key absent) = Style picker; "fit" (single listing with a Fit
     option) = the same picker labelled Fit; "fixed" (single listing, Size only) = no picker. */
  function pickerMode(D) {
    var mode = D && D.mode ? D.mode : 'style';
    if (mode === 'fixed') return { mode: mode, label: '', show: false };
    return { mode: mode, label: (D && D.style_label) || 'Style', show: true };
  }

  /* Key into a per-style map (overlay boxes, library boxes/tone). Merged products: the Style value, as always.
     Single listings (fit/fixed): the shirt's value if the map has it, else the garment label, else the map's only key. */
  function styleKey(map, style, D) {
    if (!D || !D.mode || D.mode === 'style') return style;
    if (!map) return null;
    if (Object.prototype.hasOwnProperty.call(map, style)) return style;
    if (D.garment && Object.prototype.hasOwnProperty.call(map, D.garment)) return D.garment;
    var keys = Object.keys(map);
    return keys.length === 1 ? keys[0] : null;
  }

  function buildItems(shirts, ctx) {
    var items = shirts.map(function (s, i) {
      var props = {};
      Object.keys(ctx.extra || {}).forEach(function (k) { if (ctx.extra[k]) props[k] = ctx.extra[k]; });
      if (ctx.colorway !== undefined) props.Color = ctx.colorway;
      if (ctx.design !== undefined) props.Design = ctx.design;
      props._bundle = ctx.bundleId; props._shirt = String(i + 1);
      delete props.Name; delete props['Team Name'];
      if (personalized(s)) {
        var nm = sanitize(s.name, NAME_MAX).trim(), tm = sanitize(s.team, TEAM_MAX).trim();
        if (nm) {
          props['Name'] = nm;
          if (ctx.nameColor) props['Name Color'] = ctx.nameColor;
          if (ctx.chestIcon) props['Chest Icon'] = ctx.chestIcon;
        }
        if (tm) { props['Team Name'] = tm; if (ctx.teamColor) props['Team Name Color'] = ctx.teamColor; }
      }
      return { id: s.variantId, quantity: 1, properties: props };
    });
    var persN = shirts.filter(personalized).length;
    if (persN && ctx.persVariant) items.push({ id: ctx.persVariant, quantity: persN, properties: { _bundle: ctx.bundleId } });
    if (ctx.protect && ctx.protVariant && !ctx.protInCart) items.push({ id: ctx.protVariant, quantity: 1 });
    return items;
  }

  return { TEAM_MAX: TEAM_MAX, NAME_MAX: NAME_MAX, teamLines: teamLines, sanitize: sanitize, personalized: personalized, previewText: previewText, priceFor: priceFor, hintPrices: hintPrices, calc: calc, shirtPrice: shirtPrice,
           nextFree: nextFree, bundleId: bundleId, buildItems: buildItems, cleanNote: cleanNote, overlayGeom: overlayGeom, cssStops: cssStops, textColorLabel: textColorLabel, applyStudioText: applyStudioText,
           libraryBoxes: libraryBoxes, libraryTone: libraryTone, SPORT_ICONS: SPORT_ICONS, sportOf: sportOf, iconGeom: iconGeom, pickerMode: pickerMode, styleKey: styleKey };
});
